/*--------------------------------------------------
  about-slider
--------------------------------------------------*/
document.addEventListener("DOMContentLoaded", () => {
const about = document.querySelector(".about-slider");
if (about) {
    new Swiper(about, {
    slidesPerView: 3,
    spaceBetween: 0,
    loop: true,
    allowTouchMove: false,
    speed: 10000,
    autoplay: {
        delay: 0,
        disableOnInteraction: false,
    },
    breakpoints: {
        750: {
        slidesPerView: 2,
        },
    },
    });
}
});

/*--------------------------------------------------
  thumb-slider
--------------------------------------------------*/
document.addEventListener("DOMContentLoaded", () => {
  const slider = document.querySelector(".thumb-slider");

  if (slider) {
    new Swiper(slider, {
      effect: "fade",
      loop: true,
      autoplay: {
        delay: 1500,
        disableOnInteraction: false,
      },
      speed: 3000,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 1,
        },
      },
    });
  }
});


/*-----------------------------------------------------------------------------------*/
/*	.accordion（ネイティブJS版）
/*-----------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', function () {
  const headers = document.querySelectorAll('.s_04 .accordion_one .accordion_header');

  headers.forEach(header => {
    header.addEventListener('click', function () {
      const currentInner = this.nextElementSibling;

      // 現在開いてるやつを閉じる
      headers.forEach(h => {
        const inner = h.nextElementSibling;
        if (inner !== currentInner) {
          inner.style.maxHeight = null;
          h.classList.remove('open');
        }
      });

      // クリックしたやつをトグル
      if (currentInner.style.maxHeight) {
        currentInner.style.maxHeight = null;
        this.classList.remove('open');
      } else {
        currentInner.style.maxHeight = currentInner.scrollHeight + 'px';
        this.classList.add('open');
      }

      // 「.stay」クラスが付いてるものは開いたまま維持
      headers.forEach(h => {
        if (h.classList.contains('stay')) {
          h.classList.add('open');
          const inner = h.nextElementSibling;
          if (inner) inner.style.maxHeight = inner.scrollHeight + 'px';
        }
      });
    });
  });
});
